import {
  QueuedNotificationSearchPagedRequest,
  IQueuedNotificationSearchPagedResponse,
} from "./../business-objects/common";
import { IQueuedNotificationState, QNotificationActionTypes } from "../types";
import { INotification } from "../../../common/sharedTypes";
import * as notificationService from "../../../services/notificationService";
import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";
import { QueuedNotificationSearchItem } from "../business-objects/common";

export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const SET_SELECTED_TAB = "SET_SELECTED_TAB";

export const setPagedSentNotifications = (value: QueuedNotificationSearchItem[]) => {
  return {
    type: QNotificationActionTypes.SET_PAGED_SENT_NOTIFICATIONS,
    value: value,
  };
};

export const setPagedNotifications = (value: QueuedNotificationSearchItem[]) => {
  return {
    type: QNotificationActionTypes.SET_PAGED_NOTIFICATIONS,
    value: value,
  };
};

export const setLoadingNotifications = (value: boolean) => {
  return {
    type: QNotificationActionTypes.LOADING_NOTIFICATIONS,
    value: value,
  };
};

export const setTotalNotifications = (value: number) => {
  return {
    type: QNotificationActionTypes.TOTAL_NOTIFICATIONS,
    value: value,
  };
};

export const setLoadingSentNotifications = (value: boolean) => {
  return {
    type: QNotificationActionTypes.LOADING_SENT_NOTIFICATIONS,
    value: value,
  };
};

export const setTotalSentNotifications = (value: number) => {
  return {
    type: QNotificationActionTypes.TOTAL_SENT_NOTIFICATIONS,
    value: value,
  };
};

export const setSelectedTab = (key: string) => {
  //console.log('selected', key);
  return {
    type: SET_SELECTED_TAB,
    value: key,
  };
};

export const getNotification = async (url: string): Promise<ApiResponse<INotification>> => {
  return await Api.get(url);
};

export const getPagedNotifications = async (
  url: string,
  request: QueuedNotificationSearchPagedRequest
): Promise<ApiResponse<IQueuedNotificationSearchPagedResponse>> => {
  return await Api.post(url, request);
};

export const getNotificationsPaged = (
  url: string,
  request: QueuedNotificationSearchPagedRequest
) => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingNotifications(true));
      const response: ApiResponse<IQueuedNotificationSearchPagedResponse> =
        await getPagedNotifications(url, request);

      if (response.ok) {
        dispatch(setQueueNotificationsPaged(response.data));
        dispatch(setTotalNotifications(response.data.totalResults));
      }
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoadingNotifications(false));
    }
  };
};

export const setQueueNotificationsPaged = (response: IQueuedNotificationSearchPagedResponse) => {
  return {
    type: QNotificationActionTypes.GET_QUEUED_NOTIFICATIONS_PAGED,
    value: response,
  };
};

export const getNotifications = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(getQueuedNotifications(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getQueuedNotifications = (notifications: INotification[]) => {
  return {
    type: QNotificationActionTypes.GET_QUEUED_NOTIFICATIONS,
    value: notifications,
  };
};

export const sendPagedNotifications = (url: string, ids: number[], callback: () => void) => {
  return async (dispatch) => {
    try {
      await notificationService.printAsync(url, ids);
      callback();
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const sendNotifications = (url: string, notifications: INotification[], ids: []) => {
  return async (dispatch) => {
    try {
      notificationService.print(url, ids);
      dispatch(removeNotificationsFromQueue(ids));
      dispatch(refreshSent(notifications));
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const removeNotifications = (url: string, ids: []) => {
  return async (dispatch) => {
    try {
      notificationService.remove(url, ids);
      dispatch(removeNotificationsFromQueue(ids));
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const removePagedNotifications = (url: string, ids: number[], callback: () => void) => {
  return async (dispatch) => {
    try {
      await notificationService.removeAsync(url, ids);
      callback();
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const saveUpdatedNotification = (url: string, notification: INotification) => {
  return async (dispatch) => {
    try {
      Api.put(url, notification).then((res: ApiResponse<any>) => {
        dispatch(saveUpdatedNotificationToStore(res.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const saveUpdatedPagedNotification = (
  url: string,
  notification: INotification,
  callback: () => void
) => {
  return async (dispatch) => {
    try {
      const response: ApiResponse<any> = await Api.put(url, notification);
      if (response.ok) {
        callback();
      }
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const saveUpdatedNotificationToStore = (notification: INotification) => {
  return {
    type: UPDATE_NOTIFICATION,
    value: notification,
  };
};

export const removeNotificationsFromQueue = (ids: number[]) => {
  return {
    type: QNotificationActionTypes.REMOVE_PRINTED,
    value: ids,
  };
};

export const refreshSent = (notifications: INotification[]) => {
  return {
    type: QNotificationActionTypes.REFRESH_SENT,
    value: notifications,
  };
};

export const refreshPagedSent = (notifications: QueuedNotificationSearchItem[]) => {
  return {
    type: QNotificationActionTypes.REFRESH_PAGED_SENT,
    value: notifications,
  };
};

export const getSentNotifications = (notifications: INotification[]) => {
  return {
    type: QNotificationActionTypes.GET_SENT_NOTIFICATIONS,
    value: notifications,
  };
};
